import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PermissionService } from '../services/permission.service';
import { MessageService } from 'primeng/api';

export const permissionGuard: CanActivateFn = (route, state) => {
    const permissionService = inject(PermissionService);
    const router = inject(Router);
    const messageService = inject(MessageService);

    // 從路由裡的 data['requiredPermission'] 提取需要的權限
    const requiredPermission = route.data['requiredPermission'];

    if (requiredPermission && !permissionService.hasPermission(requiredPermission)) {
        // 如果使用者沒有權限，跳出提示並回傳 false 阻止訪問
        messageService.add({
            severity: 'error',
            summary: '目前帳號無權存取該頁面',
            detail: 'Permission Denied.'
        });

        // 導回 404 或首頁
        router.navigate(['/login']);
        return false;
    }

    return true;
};
